module.exports = __webpack_public_path__ + "static/media/practice-pattern.3e29743b.png";